import React from 'react';
import { Button, Dialog, DialogContent, DialogContentText, DialogTitle } from 'web-library';
import DialogActions from 'web-library/stories/molecule/DialogActions/DialogActions';
import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import { PaymentMethod } from './PaymentApiButton';

const useStyles = makeStyles()((theme) =>
({
  paymentMethodButton: {
    marginBottom: theme.spacing(2),
  },
}));

export interface SelfPayMethodsModalProps {
  selfPayMethodsAvailable: Array<PaymentMethod>;
  modelOpen: boolean;
  onClose: () => void;
  onClickCheckout: (selectedPaymentMethod: PaymentMethod) => void;
  isDisabled: boolean;
}

const SelfPayMethodsModal = ({
  selfPayMethodsAvailable,
  modelOpen = false,
  onClose,
  isDisabled = false,
  onClickCheckout,
}: SelfPayMethodsModalProps) => {
  const { classes } = useStyles();
  return (
    <Dialog open={modelOpen} maxWidth="sm">
      <DialogTitle>Select Payment Method</DialogTitle>

      <DialogContent>
        {selfPayMethodsAvailable.includes(PaymentMethod.ENETS_CREDIT_CARD) && (
          <DialogContentText>
            <Button
              id="button-paymentMethod-enetsCreditCard"
              className={
                selfPayMethodsAvailable.includes(PaymentMethod.PAYNOW_QR) ||
                  selfPayMethodsAvailable.includes(PaymentMethod.BANK_TRANSFER)
                  ? classes.paymentMethodButton
                  : ''
              }
              disabled={isDisabled}
              onClick={() => onClickCheckout(PaymentMethod.ENETS_CREDIT_CARD)}
              fullWidth
            >
              Credit/Debit Card
            </Button>
          </DialogContentText>
        )}
        {selfPayMethodsAvailable.includes(PaymentMethod.PAYNOW_QR) && (
          <DialogContentText>
            <Button
              id="button-paymentMethod-paynowQr"
              className={
                selfPayMethodsAvailable.includes(PaymentMethod.BANK_TRANSFER)
                  ? classes.paymentMethodButton
                  : ''
              }
              disabled={isDisabled}
              onClick={() => onClickCheckout(PaymentMethod.PAYNOW_QR)}
              fullWidth
            >
              PayNow
            </Button>
          </DialogContentText>
        )}
        {selfPayMethodsAvailable.includes(PaymentMethod.BANK_TRANSFER) && (
          <DialogContentText>
            <Button
              id="button-paymentMethod-bankTransfer"
              disabled={isDisabled}
              onClick={() => onClickCheckout(PaymentMethod.BANK_TRANSFER)}
              fullWidth
            >
              Offline Payment
            </Button>
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button type="button" variant="text" onClick={() => onClose()}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SelfPayMethodsModal;
